import { PayloadAction } from "@reduxjs/toolkit";
import { LayoutState } from "../layout.slice.ts";
import { LayoutError } from "../types/layout-error.ts";
import { error } from "../../../../utilities/logger.ts";

export const errorReducer = (
  state: LayoutState,
  action: PayloadAction<LayoutError>,
) => {
  state.error = action.payload;
  if (action.payload?.error) {
    error(action.payload.error);
  }
  state.isLoading = false;
  state.isTimeOfferModalOpen = false;
};
